import {z} from 'zod';

import {TestDriveCalendarSettingsSchema, VehicleConditionSchema} from '@dms/api/sales';
import i18n from '@dms/i18n';

export const getTestDriveCalendarSettingsFormSchema = () =>
  TestDriveCalendarSettingsSchema.extend({
    branchIds: z.array(z.string()).min(1, i18n.t('errors.field_is_required')),
    vehicleConditions: z.array(VehicleConditionSchema).min(1, i18n.t('errors.field_is_required')),
    branchOverrides: z.array(
      z.object({
        branchId: z.string().min(1, i18n.t('errors.field_is_required')),
        vehicleConditions: z
          .array(VehicleConditionSchema)
          .min(1, i18n.t('errors.field_is_required')),
      })
    ),
  });

export type TestDriveCalendarSettingsFormValues = z.infer<
  ReturnType<typeof getTestDriveCalendarSettingsFormSchema>
>;
